import React from 'react';
import i18n from '../../translations/i18n';

const BULLETINS_PT = [
    {
        name: 'Boletim Tributário – Agosto/Setembro 2026',
        description: 'Confira a nova edição do nosso Boletim Tributário e fique por dentro das novidades do Poder Executivo, Reforma Tributária, Projetos de Lei, STF, STJ e CARF.',
        link: 'https://www.linkedin.com/posts/barros-pimentel-alcantara-gil-e-rodriguez-advogados_confira-a-nova-edi%C3%A7%C3%A3o-do-nosso-boletim-tribut%C3%A1rio-activity-7508209992739766272-_8GL'
    },
    {
        name: 'Boletim Tributário – Junho/Julho 2026',
        description: 'Confira o nosso Boletim Tributário e fique por dentro das novidades do Poder Executivo, Reforma Tributária, Projetos de Lei, STF, STJ e CARF.',
        link: 'https://www.linkedin.com/posts/barros-pimentel-alcantara-gil-e-rodriguez-advogados_confira-o-nosso-boletim-tribut%C3%A1rio-e-fique-activity-7483568181773783041-1-gO'
    },
    {
        name: 'Boletim de Infraestrutura – Junho/2026',
        description: 'Fique por dentro do primeiro leilão brasileiro de baterias, atualizações sobre concessões de saneamento em diversas regiões brasileiras e a recém-aprovada Política Nacional dos Minerais Críticos e Estratégicos.',
        link: 'https://www.linkedin.com/posts/barros-pimentel-alcantara-gil-e-rodriguez-advogados_vem-com-a-gente-e-fique-por-dentro-do-primeiro-activity-7472241542921986048-FVro'
    },
    {
        name: 'Boletim Tributário – Abril/Maio 2026',
        description: 'Confira a nova edição do Boletim Tributário e fique por dentro das novidades do Poder Executivo, Reforma Tributária, Projetos de Lei, STF, STJ e CARF.',
        link: 'https://www.linkedin.com/posts/barros-pimentel-alcantara-gil-e-rodriguez-advogados_confira-a-nova-edi%C3%A7%C3%A3o-do-boletim-tribut%C3%A1rio-activity-7459609153519390720-QnXd'
    },
    {
        name: 'Boletim de Infraestrutura – Março/2026',
        description: 'Destaques dos primeiros meses de 2026: avanços do marco regulatório para a descarbonização do mercado de gás natural no Brasil, novidades na estruturação de PPPs subnacionais, a realização de leilões de reserva de capacidade e impactos na segurança energética no Brasil.',
        link: 'https://www.linkedin.com/posts/barros-pimentel-alcantara-gil-e-rodriguez-advogados_confira-o-boletim-de-infraestrutura-do-barros-activity-7441913251426205697-FS9J'
    },
    {
        name: 'Boletim Tributário – Fevereiro/Março 2026',
        description: 'Está no ar mais uma edição do nosso Boletim Tributário. Confira as novidades da Receita Federal, STF, STJ e mais.',
        link: 'https://www.linkedin.com/posts/barros-pimentel-alcantara-gil-e-rodriguez-advogados_est%C3%A1-no-ar-mais-uma-edi%C3%A7%C3%A3o-do-boletim-tribut%C3%A1rio-activity-7435324431310290944-WBSc'
    },
    {
        name: 'Boletim Tributário – Dezembro/Janeiro 2026',
        description: 'Confira a primeira edição de 2026 do nosso Boletim Tributário e fique por dentro das novidades do Poder Executivo, Reforma Tributária, Projetos de Lei, STF, STJ e CARF.',
        link: 'https://www.linkedin.com/posts/barros-pimentel-alcantara-gil-e-rodriguez-advogados_confira-a-primeira-edi%C3%A7%C3%A3o-de-2026-do-boletim-activity-7424399352174903298-GzvB'
    },
    {
        name: 'Boletim de Infraestrutura – Dezembro/2025',
        description: 'Os destaques de dezembro: a modernização do marco regulatório do setor elétrico, o leilão de capacidade com baterias, contratações públicas sustentáveis, as novas diretrizes para concessões ferroviárias e muito mais.',
        link: 'https://www.linkedin.com/posts/barros-pimentel-alcantara-gil-e-rodriguez-advogados_confira-o-boletim-de-infraestrutura-do-barros-activity-7406649311788249089-IOjA'
    },
    {
        name: 'Compliance Anticorrupção',
        description: 'Confira as últimas notícias sobre medidas anticorrupção e diversidade em nosso Boletim de Compliance.',
        link: 'https://www.linkedin.com/posts/barros-pimentel-alcantara-gil-e-rodriguez-advogados_confira-as-%C3%BAltimas-not%C3%ADcias-sobre-medidas-activity-7394818769291849728-y6F9'
    },
    {
        name: 'Boletim Tributário – Setembro/Outubro 2025',
        description: 'Confira a nova edição do nosso Boletim Tributário e fique por dentro das novidades do Poder Executivo, Reforma Tributária, Projetos de Lei, STF, STJ e CARF.',
        link: 'https://www.linkedin.com/posts/barros-pimentel-alcantara-gil-e-rodriguez-advogados_confira-a-nova-edi%C3%A7%C3%A3o-do-boletim-tribut%C3%A1rio-activity-7391066661866475521-dJX4'
    }
];

const BULLETINS_EN = [
    {
        name: 'Tax Newsletter – August/September 2026',
        description: 'Check out the new edition of our Tax Newsletter and stay up to date with the latest from the Executive Branch, Tax Reform, Bills, STF, STJ and CARF.',
        link: 'https://www.linkedin.com/posts/barros-pimentel-alcantara-gil-e-rodriguez-advogados_confira-a-nova-edi%C3%A7%C3%A3o-do-nosso-boletim-tribut%C3%A1rio-activity-7508209992739766272-_8GL'
    },
    {
        name: 'Tax Newsletter – June/July 2026',
        description: 'Check out our Tax Newsletter and stay up to date with the latest from the Executive Branch, Tax Reform, Bills, STF, STJ and CARF.',
        link: 'https://www.linkedin.com/posts/barros-pimentel-alcantara-gil-e-rodriguez-advogados_confira-o-nosso-boletim-tribut%C3%A1rio-e-fique-activity-7483568181773783041-1-gO'
    },
    {
        name: 'Infrastructure Newsletter – June/2026',
        description: "Stay up to date on Brazil's first battery auction, updates on sanitation concessions across various Brazilian regions, and the recently enacted National Policy on Critical and Strategic Minerals.",
        link: 'https://www.linkedin.com/posts/barros-pimentel-alcantara-gil-e-rodriguez-advogados_vem-com-a-gente-e-fique-por-dentro-do-primeiro-activity-7472241542921986048-FVro'
    },
    {
        name: 'Tax Newsletter – April/May 2026',
        description: 'Check out the new edition of our Tax Newsletter and stay up to date with the latest from the Executive Branch, Tax Reform, Bills, STF, STJ and CARF.',
        link: 'https://www.linkedin.com/posts/barros-pimentel-alcantara-gil-e-rodriguez-advogados_confira-a-nova-edi%C3%A7%C3%A3o-do-boletim-tribut%C3%A1rio-activity-7459609153519390720-QnXd'
    },
    {
        name: 'Infrastructure Newsletter – March/2026',
        description: 'Highlights from the first months of 2026: progress on the regulatory framework for decarbonizing the natural gas market in Brazil, news on structuring subnational PPPs, capacity reserve auctions and their impact on energy security in Brazil.',
        link: 'https://www.linkedin.com/posts/barros-pimentel-alcantara-gil-e-rodriguez-advogados_confira-o-boletim-de-infraestrutura-do-barros-activity-7441913251426205697-FS9J'
    },
    {
        name: 'Tax Newsletter – February/March 2026',
        description: 'A new edition of our Tax Newsletter is out. Check out the latest from the Federal Revenue Service, STF, STJ and more.',
        link: 'https://www.linkedin.com/posts/barros-pimentel-alcantara-gil-e-rodriguez-advogados_est%C3%A1-no-ar-mais-uma-edi%C3%A7%C3%A3o-do-boletim-tribut%C3%A1rio-activity-7435324431310290944-WBSc'
    },
    {
        name: 'Tax Newsletter – December/January 2026',
        description: 'Check out the first 2026 edition of our Tax Newsletter and stay up to date with the latest from the Executive Branch, Tax Reform, Bills, STF, STJ and CARF.',
        link: 'https://www.linkedin.com/posts/barros-pimentel-alcantara-gil-e-rodriguez-advogados_confira-a-primeira-edi%C3%A7%C3%A3o-de-2026-do-boletim-activity-7424399352174903298-GzvB'
    },
    {
        name: 'Infrastructure Newsletter – December/2025',
        description: "December's highlights: the modernization of the electricity sector's regulatory framework, the battery capacity auction, sustainable public procurement, new guidelines for railway concessions and more.",
        link: 'https://www.linkedin.com/posts/barros-pimentel-alcantara-gil-e-rodriguez-advogados_confira-o-boletim-de-infraestrutura-do-barros-activity-7406649311788249089-IOjA'
    },
    {
        name: 'Anti-Corruption Compliance',
        description: 'Check out the latest news on anti-corruption and diversity measures in our Compliance Newsletter.',
        link: 'https://www.linkedin.com/posts/barros-pimentel-alcantara-gil-e-rodriguez-advogados_confira-as-%C3%BAltimas-not%C3%ADcias-sobre-medidas-activity-7394818769291849728-y6F9'
    },
    {
        name: 'Tax Newsletter – September/October 2025',
        description: 'Check out the new edition of our Tax Newsletter and stay up to date with the latest from the Executive Branch, Tax Reform, Bills, STF, STJ and CARF.',
        link: 'https://www.linkedin.com/posts/barros-pimentel-alcantara-gil-e-rodriguez-advogados_confira-a-nova-edi%C3%A7%C3%A3o-do-boletim-tribut%C3%A1rio-activity-7391066661866475521-dJX4'
    }
];

const Bulletin = ({ bulletins, setBulletins, showModal, setShowModal }) => {
    const data = i18n.language === 'en' ? BULLETINS_EN : BULLETINS_PT;

    React.useEffect(() => {
        setBulletins(data);
    }, [i18n.language]);

    return (
        <div className="boxartigos" id="bulletin-mCustomScrollbar">
            {data.map((item, index) => (
                <a onClick={() => { setShowModal('bulletin', `#bulletin-${index}`) }} key={index}>{item.name}</a>
            ))}
        </div>
    );
};

export { BULLETINS_PT, BULLETINS_EN };
export default Bulletin;
